import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(
    private meta: Meta,
    private titleService: Title,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateCanonicalLink();
    });
  }

  updateTitle(title: string) {
    this.titleService.setTitle(title);
  }

  addMetaTags(metaTags: { name: string; content: string }[]) {
    metaTags.forEach(tag => {
      this.meta.addTag({ name: tag.name, content: tag.content });
    });
  }

  updateMetaTags(metaTags: { name: string; content: string }[]) {
    metaTags.forEach(tag => {
      this.meta.updateTag({ name: tag.name, content: tag.content });
    });
  }

  updateCanonicalLink(url?: string) {
    const canonicalLink = this.document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', url || this.document.URL);
    } else {
      const link: HTMLLinkElement = this.document.createElement('link');
      link.setAttribute('rel', 'canonical');
      link.setAttribute('href', url || this.document.URL);
      this.document.head.appendChild(link);
    }
  }
}